import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Megaphone, Send, Trash2 } from "lucide-react";

const fmt = (iso) => {
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const CellAnnouncements = ({ g, onChange }) => {
  const [text, setText] = useState("");
  const [posting, setPosting] = useState(false);
  const list = g.announcements || [];

  const post = async () => {
    if (text.trim().length < 2) { toast.error("Write a short update first"); return; }
    setPosting(true);
    try { await api.post("/portal/cell/announcements", { message: text.trim() }); setText(""); toast.success("Update posted to your group"); onChange(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setPosting(false);
  };
  const remove = async (n) => {
    if (!window.confirm("Remove this update?")) return;
    try { await api.delete(`/portal/cell/announcements/${n.id}`); toast.success("Update removed"); onChange(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (!g.can_post && list.length === 0) return null;
  return (
    <div className="bg-white rounded-2xl border border-[#EBE9E4] shadow-[0_8px_30px_rgba(45,45,45,0.04)] p-6" data-testid="cell-announcements">
      <h3 className="font-head text-lg font-semibold flex items-center gap-2 mb-3"><Megaphone className="h-5 w-5" style={{ color: "var(--sj-primary)" }} /> Group updates</h3>
      {g.can_post && (
        <div className="mb-4">
          <textarea data-testid="cell-announcement-input" rows={2} maxLength={500} value={text} onChange={(e) => setText(e.target.value)}
            placeholder="Share a note with your group, e.g. “This week we're meeting at 7:30pm — bring a friend!”"
            className="w-full bg-[#EDF2F4] border border-[#EBE9E4] rounded-xl focus:ring-2 focus:ring-[#0B5E4E]/20 outline-none px-3 py-2.5 text-sm resize-none" />
          <div className="mt-2 flex items-center justify-between gap-2">
            <span className="text-[11px]" style={{ color: "var(--sj-text-3)" }}>{500 - text.length} characters left · everyone in the group is notified in their portal</span>
            <button data-testid="cell-announcement-post" disabled={posting || text.trim().length < 2} onClick={post} className="inline-flex items-center gap-1.5 rounded-xl px-4 py-2 text-sm font-semibold disabled:opacity-50" style={{ background: "var(--sj-accent)", color: "#063B30" }}>
              <Send className="h-4 w-4" /> {posting ? "Posting…" : "Post update"}
            </button>
          </div>
        </div>
      )}
      {list.length === 0 ? (
        <p className="text-sm" style={{ color: "var(--sj-text-3)" }}>No updates yet. Post the first one for your group.</p>
      ) : (
        <div className="space-y-2.5">
          {list.map((n) => (
            <div key={n.id} data-testid={`cell-announcement-${n.id}`} className="rounded-xl px-4 py-3" style={{ background: "#F7FAF8", borderLeft: "3px solid var(--sj-accent)" }}>
              <div className="flex items-start justify-between gap-3">
                <p className="text-sm whitespace-pre-line" style={{ color: "var(--sj-text)" }}>{n.message}</p>
                {n.can_delete && <button data-testid={`cell-announcement-delete-${n.id}`} onClick={() => remove(n)} title="Remove update" className="shrink-0 p-1 rounded opacity-50 hover:opacity-100" style={{ color: "#B42318" }}><Trash2 className="h-3.5 w-3.5" /></button>}
              </div>
              <div className="text-[11px] mt-1" style={{ color: "var(--sj-text-3)" }}>{n.author_name} · {fmt(n.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
